export default __webpack_public_path__ + "static/media/1_3_hl.ad6fe910.png";